import { useMutation } from "react-query";
import api from "../../client";
import {
  CreatePlacementEnvironmentTemplatePayload,
  PlacementEnvironmentTemplateListItem,
} from "../../types/placement-environment-template";

const postData = async (
  payload: CreatePlacementEnvironmentTemplatePayload,
): Promise<PlacementEnvironmentTemplateListItem> => {
  const { data } = await api.post(`/placement-environment-templates`, payload);

  return data;
};

export const useCreatePlacementEnvironmentTemplate = () => {
  return useMutation((payload: CreatePlacementEnvironmentTemplatePayload) => {
    return postData(payload);
  });
};
